import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "logout",
  "use": "logout-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\" id=\"logout\"><path d=\"M17.6 17.6v-3.627H6.72l2.667-2.667-2.453-2.453-6.933 6.933 6.933 6.933 2.453-2.453-2.667-2.667zm7.253-14.08H14.186v3.627h10.667v17.707H14.186v3.627h14.293V3.521z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol